import MonetaryCompensationService from '@/views/MonetaryCompensationService/index.vue'

const MonetaryCompensationServiceRouter = {
  path: '/monetary-compensation-service',
  name: 'MonetaryCompensationService',
  component: MonetaryCompensationService,
  props: (route) => ({
    secret: route.query.secret,
    monetaryId: route.query.monetary_id,
    orderId: route.query.order_id
  })
}

export default MonetaryCompensationServiceRouter
